import React from 'react';
import { connect } from 'react-redux';

class ProjectName extends React.Component {

    render() {
          return(
            <div>
                <div className="card-section">
                    <h4 className="text" style={{marginBottom: 0}}>
                        { this.props.projectName }
                    </h4>
                </div>
            </div>
        );
    } 
}

function mapStateToProps( state ){
    return { 
    	projectName : state.projectData.attributes.name,
    }
}

export default connect(mapStateToProps)(ProjectName);